export const SECTION_LEVELS = ["쌩기초", "기초", "심화", "호기심"] as const;

export type SectionLevelName = (typeof SECTION_LEVELS)[number];

export const SECTION_LEVEL_STYLES: Record<SectionLevelName, string> = {
  쌩기초:
    "bg-emerald-100 text-emerald-700 border-emerald-300 dark:bg-emerald-950/50 dark:text-emerald-400 dark:border-emerald-800",
  기초: "bg-blue-100 text-blue-700 border-blue-300 dark:bg-blue-950/50 dark:text-blue-400 dark:border-blue-800",
  심화: "bg-amber-100 text-amber-700 border-amber-300 dark:bg-amber-950/50 dark:text-amber-400 dark:border-amber-800",
  호기심:
    "bg-violet-100 text-violet-700 border-violet-300 dark:bg-violet-950/50 dark:text-violet-400 dark:border-violet-800",
};

export const SECTION_LEVEL_DESCRIPTIONS: Record<SectionLevelName, string> = {
  쌩기초: "전공자가 아니어도 처음 보고 이해할 수 있는 가장 기본 개념입니다.",
  기초: "시험 합격을 위해 반드시 알아야 하는 핵심 개념입니다.",
  심화: "변형 문제나 응용 문제에 대비하기 위한 한 단계 깊은 내용입니다.",
  호기심:
    "필수는 아니지만 호기심이 있다면 읽어보세요. 시험에 직접 출제될 가능성은 낮습니다.",
};
